import { API_V1 } from 'API';
import { ILogin } from 'models/services/authenticate';
import { User } from 'models/user';

export async function Login(user: ILogin) {
    return await API_V1.post<User>('merchant-user/authenticate', user);
}
